<template>
  <footer class="app-foot">
    <div class="app-foot-cols">
      <div>
        <span class="vm-mark">
          <img
            class="vm-logo"
            src="../assets/images/logo-videomedi-white.png"
            alt="Videomedi"
          />
        </span>
        <p class="blurb">
          Saúde por vídeo, sem burocracia. Especialistas verificados, receita e
          atestado digitais em poucos minutos.
        </p>
      </div>
      <div>
        <h5>Plataforma</h5>
        <router-link :to="{ path: '/', query: { buscar: '1' } }">
          Buscar profissionais de saúde
        </router-link>
        <router-link :to="{ path: '/', query: { buscar: '1' } }">
          Especialidades
        </router-link>
        <!-- Minhas consultas: disponível apenas para usuário logado
        <router-link :to="{ name: 'Consultas' }">Minhas consultas</router-link>
        -->
        <!-- Como funciona: link indisponível no momento
        <router-link :to="{ name: 'How to work' }">Como funciona</router-link>
        -->
      </div>
      <!-- Empresa: links indisponíveis no momento
      <div>
        <h5>Empresa</h5>
        <a href="#">Sobre</a>
        <a href="#">Para empresas</a>
        <a href="#">Seja um profissional de saúde</a>
        <a href="#">Imprensa</a>
      </div>
      -->
      <!-- Suporte: links indisponíveis no momento
      <div>
        <h5>Suporte</h5>
        <a href="#">Central de ajuda</a>
        <a href="#">Contato</a>
        <a href="#">Status do sistema</a>
      </div>
      -->
      <!-- Legal: links indisponíveis no momento
      <div>
        <h5>Legal</h5>
        <a href="#">Privacidade</a>
        <a href="#">Termos de Uso</a>
        <a href="#">LGPD</a>
        <a href="#">Cookies</a>
      </div>
      -->
    </div>
    <div class="app-foot-bottom">
      <span>© 2026 Videomedi · CNPJ 00.000.000/0001-00</span>
      <span>Responsável técnica: Dra. Renata Alves · CRM 12345 AL</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style lang="scss" scoped>
.app-foot {
  background: var(--color-gray-900);
  color: var(--color-gray-300);
  padding: var(--space-10) var(--space-10) var(--space-8);

  .vm-mark {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
  }

  .vm-logo {
    display: block;
    height: 24px;
    width: auto;
  }

  .blurb {
    font-size: var(--font-size-sm);
    color: var(--color-gray-400);
    margin-top: var(--space-3);
    max-width: 280px;
    line-height: 1.6;
  }

  h5 {
    color: #fff;
    font-size: var(--font-size-sm);
    font-weight: var(--fw-bold);
    margin-bottom: var(--space-3);
  }

  a {
    display: block;
    font-size: var(--font-size-sm);
    color: var(--color-gray-400);
    padding: 4px 0;
    text-decoration: none;

    &:hover {
      color: #fff;
    }
  }
}

.app-foot-cols {
  display: grid;
  grid-template-columns: 1.6fr repeat(4, 1fr);
  gap: var(--space-8);

  @media (max-width: 860px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
}

.app-foot-bottom {
  border-top: 1px solid var(--color-gray-700);
  margin-top: var(--space-8);
  padding-top: var(--space-5);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-xs);
  color: var(--color-gray-500);
  flex-wrap: wrap;
  gap: var(--space-3);
}
</style>
